import { FormProvider } from 'react-hook-form';
import { z } from 'zod';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { Panel } from '~/components/common/Panel';
import { OutcropGeoreferencesExport } from '~/components/upload/georeference/OutcropGeoreferencesExport';
import { OutcropSelectV4 } from '~/components/upload/outcrop/outcrop-select-v4';
import { useZodForm } from '~/utils/forms';
import { ppNumberOrNull } from '~/utils/zod';

export default function ExportGeoreferencesOutcropRoute() {
  const form = useZodForm({
    schema: z.object({
      outcropId: z.preprocess(ppNumberOrNull, z.number().int()),
    }),
    values: { outcropId: '' },
  });

  const outcropIdValue = form.watch('outcropId');
  const outcropId = outcropIdValue ? parseInt(outcropIdValue) : null;

  return (
    <ApolloProviderV4>
      <FormProvider {...form}>
        <form>
          <Panel>
            <Panel.Heading>
              <Panel.Title>Export Outcrop Georeferences</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <OutcropSelectV4 name="outcropId" label="Outcrop" />
            </Panel.Body>

            {outcropId && (
              <Panel.Footer className="text-right">
                <OutcropGeoreferencesExport outcropId={outcropId} />
              </Panel.Footer>
            )}
          </Panel>
        </form>
      </FormProvider>
    </ApolloProviderV4>
  );
}
